import React from "react";
import { AiOutlinePlusCircle } from "react-icons/ai";
import { Image, Row, Space, Table, Tag } from "antd";
import useLanguage from "../hooks/useLanguage";
import { useLoad } from "../hooks/request";
import { videoDelete, videoList } from "../utils/url";
import EditDrawerBtn from "../components/Atoms/Buttons/EditDrawerBtn";
import DeleteModalBtn from "../components/Atoms/Buttons/DeleteModalBtn";
import PostDrawerBtn from "../components/Atoms/Buttons/PostDrawerBtn";
import StatusTag from "../components/Atoms/StatusTag/StatusTag";
import { useGetTitle } from "../hooks/useGetTitle";

export default function VideosPage() {
  const { translateTitle } = useGetTitle();
  const getRequest = useLoad({ url: videoList });
  const { response, loading } = getRequest;
  const translate = useLanguage();

  const columns = [
    {
      title: "Image",
      dataIndex: "image",
      render: (record) => (
        <Row align="middle" justify="center" style={{ width: 120, height: 50 }}>
          <Image
            width="100%"
            height="100%"
            src={record}
            alt="image"
            style={{ objectFit: "cover" }}
          />
        </Row>
      ),
    },
    {
      title: "Title",
      dataIndex: translateTitle("title"),
      key: "title",
      ellipsis: true,
    },
    {
      title: "Link",
      dataIndex: "youtube_link",
      key: "youtube_link",
      ellipsis: true,
      responsive: ["lg"],
      render: (value) =>
        value ? (
          <a href={value} target="_blank" rel="noreferrer">
            {value}
          </a>
        ) : (
          "—"
        ),
    },
    {
      title: "Placement",
      key: "placement",
      width: 170,
      render: (_, record) => (
        <Space size={4} wrap>
          {record.is_home === 1 && (
            <Tag color="blue" bordered={false}>
              Home
            </Tag>
          )}
          {record.is_podcast === 1 && (
            <Tag color="red" bordered={false}>
              Podcast
            </Tag>
          )}
          {record.is_home !== 1 && record.is_podcast !== 1 && "—"}
        </Space>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      width: 120,
      render: (value) => <StatusTag value={value} />,
    },
    {
      title: "",
      key: "actions",
      width: 200,
      render: (_, record) => (
        <Space className="crud__actions">
          <EditDrawerBtn
            type={"videos"}
            data={record}
            request={getRequest.request}
          />
          <DeleteModalBtn
            url={videoDelete}
            id={record._id}
            request={getRequest.request}
          />
        </Space>
      ),
    },
  ];

  return (
    <section className="page">
      <header className="page__header">
        <h1 className="page__title">Videos</h1>
        <PostDrawerBtn type={"videos"} request={getRequest.request}>
          <AiOutlinePlusCircle className="icon" />
          {translate("add-videos")}
        </PostDrawerBtn>
      </header>
      <div className="page__content">
        <Table
          columns={columns}
          dataSource={response?.data?.videos}
          scroll={{ x: "max-content" }}
          loading={loading}
          rowKey="id"
        />
      </div>
    </section>
  );
}
